// Utility functions for chart filters
import { useChartFilters } from './Chat.Chart.Filter.Context';

type ChartFilter = {
  selectedOption?: { value: string };
  valueOption?: Array<{ value: string }>;
};

type ChartFilterRow = {
  id: number;
  selectedOption: { value: string; label: string } | null;
  valueOption: { value: string; label: string }[];
};

/**
 * Calculate the number of active chart filters for a specific chart
 */
export function calculateActiveChartFiltersCount(chartFilters: ChartFilterRow[]): number {
  if (!chartFilters || !Array.isArray(chartFilters)) return 0;

  return chartFilters.filter(filter => {
    // A filter is considered active if it has values selected
    return Array.isArray(filter.valueOption) && filter.valueOption.length > 0;
  }).length;
}

/**
 * Hook to get the active filters count for a specific chart
 */
export function useActiveChartFiltersCount(chartId: string): number {
  const chartFiltersMap = useChartFilters() as Record<string, ChartFilterRow[]>;
  const filters = chartFiltersMap[chartId] ?? [];

  return calculateActiveChartFiltersCount(filters);
}